var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Right arrow"),React.createElement("path",{"d":"M23.6 48l-4.8-5 12.7-13-12.7-13 4.8-5 17.6 18z","key":1})]);
}

ArrowRight.defaultProps = {"viewBox":"0 0 60 60","id":"right","width":"100%","height":"100%"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
